import { Application, Text } from 'pixi.js'
import GameGlobals from '../../components/Game/GameGlobals'
import { nodePalette } from '../../theme'
import LivingObject, { LivingObjectOptions } from "../modules/LivingObject"

export type SimpleEntityOptions = {
	symbol?: string
	color?: string
	size?: number
} & LivingObjectOptions

export default class SimpleEntity extends LivingObject {
	symbol
	color
	size
	evented = false

	static entityName = "Entity"

	constructor({ symbol = '', color = nodePalette.background, size = 40, ...rest }: SimpleEntityOptions) {
		super(rest)

		this.symbol = symbol
		this.color = color
		this.size = size
	}

	createGraphics() {
		const text = new Text(this.symbol, { fontFamily: 'Segoe UI Emoji', fontSize: this.size, align: 'center' })
		text.anchor.set(0.5)
		return text
	}

	tick(delta: number) {
		super.tick(delta)

		if (this.graphics) {
			this.graphics.x = this.position.x
			this.graphics.y = this.position.y
		}
	}

	addGraphics(pixi: Application) {
		super.addGraphics(pixi)

		if (pixi && this.graphics) {
			this.graphics.x = this.position.x
			this.graphics.y = this.position.y
			this.graphics.on('mousedown', () => {
				GameGlobals.setSelectedEntity(this)
			})
		}

	}

	getName() {
		// @ts-ignore
		return this.constructor.entityName
	}
}